var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdressImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.03109 5.917L17.5081 1.583C17.5936 1.55909 17.6839 1.55836 17.7697 1.5809C17.8556 1.60344 17.9339 1.64843 17.9966 1.71125C18.0594 1.77407 18.1042 1.85245 18.1266 1.93835C18.149 2.02424 18.1481 2.11455 18.1241 2.2L13.7911 17.676C13.7635 17.7756 13.7058 17.8641 13.6259 17.9296C13.546 17.995 13.4478 18.0341 13.3447 18.0414C13.2417 18.0487 13.1389 18.024 13.0505 17.9706C12.9622 17.9171 12.8925 17.8376 12.8511 17.743L9.60309 10.361C9.55293 10.2463 9.46158 10.1546 9.34709 10.104L1.96509 6.856C1.87043 6.8147 1.79089 6.74511 1.73738 6.65678C1.68388 6.56845 1.65903 6.46572 1.66627 6.3627C1.6735 6.25969 1.71245 6.16144 1.77778 6.08145C1.8431 6.00146 1.93159 5.94367 2.03109 5.916V5.917Z",
    stroke: "#43B4E9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdressImg);
export default __webpack_public_path__ + "static/media/adress-img.53d043be9001062b04818cd4007ce090.svg";
export { ForwardRef as ReactComponent };